import { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { ARAR } from '../autoReturnAndResend.classes';

interface AutoReturnAndResendPanelHeaderProps {
    title?: string;
    actions?: ReactNode;
}

export const AutoReturnAndResendPanelHeader: FC<AutoReturnAndResendPanelHeaderProps> = ({ title, actions }) => (
    <Box
        className={ARAR.panelHeader}
        sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            mb: 2,
        }}
    >
        {title && (
            <Typography variant="h6" component="h2">
                {title}
            </Typography>
        )}
        {actions && (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'flex-end', ml: 'auto' }}>
                {actions}
            </Box>
        )}
    </Box>
);
